import { IImpact } from "@/pages/dashboard/utils/types";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export function useSourceHeatImpact({
  facilityId,
  sourceUrn,
  amount,
  unit,
}: {
  facilityId: number;
  sourceUrn: string;
  amount: number | null;
  unit: string;
}) {
  const query = useQuery({
    keepPreviousData: true,
    queryKey: ["heat_impact", facilityId, sourceUrn, amount, unit],
    queryFn: () =>
      axios
        .get<IImpact>(`/contracts/calculate_heat_impact`, {
          params: {
            facility_id: facilityId,
            source_urn: sourceUrn,
            amount: amount,
            unit: unit,
          },
        })
        .then((result) => result.data),
  });

  return query;
}
